import request from "@/utils/request";

export default function page(current=1,size=10,params) {
    return request({
        url: `/storeProduct/agency/page/`+current+`/`+size,
        method: 'get',
        params
    })
}
